import React, { useState } from "react";
import useForm from "antd/es/form/hooks/useForm";
import request from "project-config/services/request/request";
import { useDingTalkSubAccountStore } from "../../../store/dingtalk-subaccount-store";
import { message } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";

export function useChildManageSider() {
  const t = getTranslateNsT("center");
  const childManagerT = getTranslateNsT("childManager");
  let currentExpandKeys: number[] = [];
  const [openSubNameModal, setOpenSubNameModal] = useState(false);
  const [openDeleteDeptModal, setOpenDeleteDeptModal] = useState(false);
  const [currentBtnStatus, setCurrentBtnStatus] = useState(true);
  const [enterpriseAliasForm] = useForm<{
    enterpriseAlias: string;
  }>();
  const {
    queryDeptList,
    setCheckTreeKeys,
    setCheckTreeInfo,
    queryDingTalkAppSettings,
    setIsAutoExpandParent,
    setExpandedDeptyKeys,
    expandeDeptyKeys,
    initDeptInfo,
    setDeptInfo,
    checkTreeInfo,
    setIsSearchExpandKey,
  } = useDingTalkSubAccountStore();
  const handleWatchInputValue = () => {
    if (!openSubNameModal) return;
    enterpriseAliasForm.validateFields().then(
      () => {
        setCurrentBtnStatus(true);
      },
      () => {
        setCurrentBtnStatus(false);
      }
    );
  };

  const handleDeleteDept = async (params: {
    deptIdList: (number | null)[];
  }) => {
    const { code } = await request.post(
      "/api/rendering/user/deleteDeptList",
      params
    );
    if (code === 200) message.success(t("user_deleted_success"));
    if (code === 1316)
      message.error(childManagerT("dingtalk_subaccount_dept_delete_error"));
    queryDeptList();
    setOpenDeleteDeptModal(false);
    setCheckTreeKeys([]);
    setCheckTreeInfo([]);
    setIsAutoExpandParent(true);
  };

  const getCheckKeySyncStatus = (status: number) => {
    const result =
      checkTreeInfo.filter((item) => item.isSync === status).length ===
      checkTreeInfo.length;
    return result;
  };

  const handleEditEnterpriseName = async () => {
    if (!enterpriseAliasForm) return;
    enterpriseAliasForm
      .validateFields()
      .then(async () => {
        const { code } = await request.post(
          "/api/rendering/user/setEnterpriseAlias",
          {
            enterpriseAlias:
              enterpriseAliasForm.getFieldValue("enterpriseAlias"),
          }
        );
        if (code !== 200) return;
        enterpriseAliasForm.resetFields();
        setOpenSubNameModal(false);
        message.success(t("user_com_modify_label_success_msg"));
        await queryDingTalkAppSettings();
      })
      .catch(() => {});
  };

  const getFilterDept = (
    arr: any,
    keyword: string,
    field = "name",
    first = true
  ) => {
    if (first) {
      arr = JSON.parse(JSON.stringify(arr));
    }
    let emptyArr = [];
    for (let item of arr) {
      if (item[field].includes(keyword)) {
        currentExpandKeys.push(item.keyIndex);
        if (
          item.deptList &&
          Array.isArray(item.deptList) &&
          item.deptList.length > 0
        ) {
          item.deptList = getFilterDept(
            item.deptList,
            keyword,
            field,
            false
          ).data;
        }
        emptyArr.push(item);
      } else if (
        item.deptList &&
        Array.isArray(item.deptList) &&
        item.deptList.length > 0
      ) {
        item.deptList = getFilterDept(
          item.deptList,
          keyword,
          field,
          false
        ).data;
        if (item.deptList.length) {
          emptyArr.push(item);
        }
      }
    }
    return { data: emptyArr, key: currentExpandKeys };
  };
  const handleFilterDept = (value: string) => {
    currentExpandKeys = [];
    if (value === "" || value === undefined) {
      setIsSearchExpandKey(false);
      setDeptInfo(initDeptInfo);
      setExpandedDeptyKeys(expandeDeptyKeys);
      return;
    }
    const { data, key } = getFilterDept(initDeptInfo, value);
    setDeptInfo(data);
    setExpandedDeptyKeys(key as React.Key[]);
    setIsSearchExpandKey(true);
    setIsAutoExpandParent(true);
  };

  return {
    openSubNameModal,
    setOpenSubNameModal,
    currentBtnStatus,
    setCurrentBtnStatus,
    enterpriseAliasForm,
    handleWatchInputValue,
    handleDeleteDept,
    getCheckKeySyncStatus,
    handleEditEnterpriseName,
    handleFilterDept,
    openDeleteDeptModal,
    setOpenDeleteDeptModal,
  };
}
